import { Route, Routes } from "react-router-dom";
import Welcome from "../Welcome";
import Login from "../Login";
import Register from "../Register";
import Layout from "../Layout";
import {sitemap} from "../Layout/Sitemap";
import EmailConfirm from "../Register/EmailConfirm";
import RegisterCompleted from "../Register/RegisterCompleted";

const Router = () => (
    <Routes>
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/completed" element={<RegisterCompleted />} />
        <Route path="/confirm" element={<EmailConfirm />} />
        <Route path="*" element={<Layout sitemap={sitemap}/>} />
    </Routes>
);

export default Router;